import { createStore, applyMiddleware } from "redux";

import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import reducers from "./reducers";

const userInfoLocalStorage = localStorage.getItem("user_info")
  ? JSON.parse(localStorage.getItem("user_info"))
  : {
      error: null,
      user: {
        id: "",
        name: "",
        token: "",
        email: "",
        authenticated: false
      },
    };

    const profileInfoFromLocalStorage = localStorage.getItem("profile_info") ? JSON.parse(localStorage.getItem("profile_info")) : {}
const initialState = {
  Auth: { user: userInfoLocalStorage },
  ProfileDetails: {
    profile: profileInfoFromLocalStorage
  }
};
const store = createStore(
  reducers,
  initialState,
  composeWithDevTools(applyMiddleware(thunk))
);

export default store;
